import React from 'react';
import { HealthDial } from '../HealthDial';
import { Reveal } from '../Reveal';
import { healthBands, healthEngine, healthValue } from '../../data/site';
export function HealthEngine() {
  return <section id="health" className="border-b border-line bg-cream" data-id="element-103" data-mp="ari7ufg0n0qa">
      <div className="mx-auto max-w-[1180px] px-5 py-20 sm:px-8 lg:py-28" data-id="element-104" data-mp="aue664vrzrf9">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.92fr)] lg:items-center lg:gap-16" data-id="element-105" data-mp="fqcy22gbbrkf">
          <div data-id="element-106" data-mp="3eav102az21vb">
            <p className="micro-label text-[9px] text-gold-600" data-id="element-107" data-mp="3j7v5w9w34yku">KeyTurn Health</p>
            <h2 className="mt-4 max-w-[18ch] font-display text-[38px] font-semibold leading-[1.02] tracking-[-0.035em] text-charcoal-700 sm:text-[52px]" data-id="element-108" data-mp="3j9xvistbspp1">
              {healthEngine.headline}
            </h2>
            <p className="mt-6 max-w-[54ch] text-[16px] leading-relaxed text-charcoal-700" data-id="element-109" data-mp="3t3ogvou5ok0i">
              {healthEngine.lead}
            </p>
            <p className="mt-4 max-w-[54ch] text-[15px] leading-relaxed text-charcoal-500" data-id="element-110" data-mp="18f0mg6wcyx27">
              {healthEngine.support}
            </p>

            <div className="mt-8 border-t border-charcoal-700 pt-5" data-id="element-111" data-mp="18n9jtnx3d7nf">
              <p className="micro-label text-[8.5px] text-charcoal-400" data-id="element-112" data-mp="13rkhxdxlneny">What it reads</p>
              <ul className="mt-3 flex flex-wrap gap-x-5 gap-y-2" data-id="element-113" data-mp="znml59vqyfy2">
                {healthEngine.inputs.map(input => <li key={input} className="whitespace-nowrap text-[13px] text-charcoal-600 before:mr-5 before:text-warmgrey before:content-['·'] first:before:hidden" data-id="element-114" data-mp="upba4vtptze9">
                    {input}
                  </li>)}
              </ul>
            </div>
          </div>

          <Reveal className="rounded-2xl border border-line bg-white p-6 shadow-sm sm:p-8" data-id="element-115" data-mp="bzmue9yfqpjh">
            <div className="flex items-center gap-6 border-b border-line pb-7" data-id="element-116" data-mp="6zqo2429mm0r">
              <HealthDial score={64} previous={69} size={116} animate delay={0.1} data-id="element-117" data-mp="71uqehkincyx" />
              <div className="min-w-0" data-id="element-118" data-mp="2309jl63zyhg">
                <p className="micro-label text-[8.5px] text-charcoal-400" data-id="element-119" data-mp="3oi5zlgt3qih4">Portfolio Health</p>
                <p className="mt-2 font-display text-[19px] font-medium leading-snug tracking-[-0.02em] text-charcoal-700" data-id="element-120" data-mp="3thik3uwi3dgj">
                  Two openings need intervention this week
                </p>
                <p className="mt-1.5 text-[12px] text-charcoal-400" data-id="element-121" data-mp="3jj2tdt1dy67k">
                  Down 5 since last week, across 14 live projects
                </p>
              </div>
            </div>

            <ul className="divide-y divide-line" data-id="element-122" data-mp="g2mb0v3dlo8e">
              {healthBands.map((band, index) => <li key={band.label} className="flex items-start gap-4 py-4" data-id="element-123" data-mp="1ej4nklf8aj2" data-mpi={index}>
                  <HealthDial score={band.score} previous={band.previous} size={44} animate delay={0.24 + index * 0.09} data-id="element-124" data-mp="6d2s5pfnxudj" />
                  <div className="min-w-0" data-id="element-125" data-mp="yuf4srq9rdh6">
                    <p className="text-[13.5px] font-semibold text-charcoal-700" data-id="element-126" data-mp="yvghf0mxo810">
                      {band.label}{' '}
                      <span className="font-normal tabular-nums text-charcoal-300" data-id="element-127" data-mp="2ekz85yu25nk2">
                        {band.range}
                      </span>
                    </p>
                    <p className="mt-1 text-[12.5px] leading-snug text-charcoal-500" data-id="element-128" data-mp="2tbokj4j998pi">{band.blurb}</p>
                  </div>
                </li>)}
            </ul>
          </Reveal>
        </div>

        <dl className="mt-16 grid gap-x-12 sm:grid-cols-3" data-id="element-129" data-mp="20mrf420576e6">
          {healthValue.map(item => <div key={item.title} className="border-t border-line py-5" data-id="element-130" data-mp="1vo6fo4spsqqs">
              <dt className="text-[14px] font-semibold text-charcoal-700" data-id="element-131" data-mp="29mxphf0jnq94">{item.title}</dt>
              <dd className="mt-2 text-[13px] leading-relaxed text-charcoal-500" data-id="element-132" data-mp="25ig8tophdt2k">{item.body}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}